export const groupQueryKeys = {
    foyer: 0 /* GroupIndex.Foyer */,
    auditorium: 1 /* GroupIndex.Auditorium */,
    streaming: 2 /* GroupIndex.Streaming */,
};
